export function validKubeflowNamespaceName(name) {
  return String(name).match(/^([a-z0-9.-])+$/);
}

export function validKubeflowNamespaceNameFirstChar(name) {
  return String(name)
    .substring(0, 1)
    .match(/^([a-z0-9])+$/);
}

export function validKubeflowNamespaceNameLastChar(name) {
  return String(name)
    .slice(-1)
    .match(/^([a-z0-9])+$/);
}
